import React, { Fragment, useEffect, useState } from 'react'
import moment from 'moment'

import withStyles from '@material-ui/core/styles/withStyles'
import SimpleTableTable from 'Components/SimpleTableTable'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { FiltersWrapper } from 'Components/Filter/FiltersWrapper'
import { FilterBox } from 'Components/Filter/FiltersWrapper/box'
import { FilterSelect } from 'Components/Filter/FilterSelect'

import { styles } from '../styles'
import useGraphQLFetch from '../../../../../Utils/Hooks/useGraphQLFetch'
import { getLogs } from './graphQL'

const header = ['Date', 'Type', 'Description', 'User']

const DEFAULT_FILTER_VALUES = {
  ALL: 'ALL',
  ASC: 'ASC',
  DESC: 'DESC',
}

function compareDates(a, b) {
  return new Date(a.Date).getTime() - new Date(b.Date).getTime()
}

const LogsContainer = ({ classes, campaignId }) => {
  const [logs, setLogsData] = useState([])
  const [filterOptions, setFilterOptions] = useState({
    types: [DEFAULT_FILTER_VALUES.ALL],
    users: [DEFAULT_FILTER_VALUES.ALL],
    sortByTimes: [DEFAULT_FILTER_VALUES.ASC, DEFAULT_FILTER_VALUES.DESC],
  })
  const [filters, setFilters] = useState({
    type: DEFAULT_FILTER_VALUES.ALL,
    user: DEFAULT_FILTER_VALUES.ALL,
    time: DEFAULT_FILTER_VALUES.DESC,
  })

  const [firstRenderedData, setFirstRenderedData] = useState([])
  const { data, isLoaded } = useGraphQLFetch({
    fetchFn: getLogs,
    defaultFetchArgs: {
      campaignId,
    },
    mapResponse: data =>
      data.campaign.logs.map(({ type, additionalInfo, createdAt, user }) => ({
        'Type': type
          .split('_')
          .map(item => {
            const lower = item.toLowerCase()
            return `${lower.charAt(0).toUpperCase()}${lower.slice(1)} `
          })
          .join(''),
        'Description': additionalInfo,
        'User': `${user.firstName} ${user.lastName} (${user.role})`,
        'Date': moment(createdAt).format('YYYY/MM/DD HH:mm:ss'),
      })),
  })

  useEffect(() => {
    if (isLoaded) {
      const { types, users } = data.reduce(
        (acc, item) => {
          acc.types.push(item.Type)
          acc.users.push(item.User)
          return acc
        },
        {
          types: [DEFAULT_FILTER_VALUES.ALL],
          users: [DEFAULT_FILTER_VALUES.ALL],
        },
      )

      setFilterOptions(prev => ({
        ...prev,
        types: [...new Set(types)],
        users: [...new Set(users)],
      }))

      setFirstRenderedData(data)
    }
  }, [isLoaded])

  useEffect(() => {
    if (firstRenderedData.length) {
      let logs = [...firstRenderedData]
      logs = logs.filter(log => {
        if (
          filters.user !== DEFAULT_FILTER_VALUES.ALL &&
          filters.type !== DEFAULT_FILTER_VALUES.ALL
        ) {
          return log.User === filters.user && log.Type === filters.type
        } else if (
          filters.user === DEFAULT_FILTER_VALUES.ALL &&
          filters.type !== DEFAULT_FILTER_VALUES.ALL
        ) {
          return log.Type === filters.type
        } else if (
          filters.user !== DEFAULT_FILTER_VALUES.ALL &&
          filters.type === DEFAULT_FILTER_VALUES.ALL
        ) {
          return log.User === filters.user
        } else {
          return log
        }
      })

      let sortedLogs
      if (filters.time === DEFAULT_FILTER_VALUES.DESC) {
        sortedLogs = logs.slice().sort((a, b) => compareDates(b, a))
      } else {
        sortedLogs = logs.slice().sort(compareDates)
      }
      setLogsData(sortedLogs)
    }
  }, [filters.time, filters.user, filters.type, firstRenderedData])

  return (
    <Fragment>
      <div className={classes.tableWrapper}>
        <LayoutDashboard>
          <FiltersWrapper style={{ maxWidth: '50%' }}>
            <FilterBox>
              <FilterSelect
                hasPrimaryText={false}
                label="Type"
                onChange={(e, index, value) =>
                  setFilters(prev => ({ ...prev, type: value }))
                }
                options={filterOptions.types.map(item => ({
                  label: item,
                  value: item,
                }))}
                value={filters.type}
                sorted={false}
              />
            </FilterBox>
            <FilterBox>
              <FilterSelect
                hasPrimaryText={false}
                label="User"
                onChange={(e, index, value) =>
                  setFilters(prev => ({ ...prev, user: value }))
                }
                options={filterOptions.users.map(item => ({
                  label: item,
                  value: item,
                }))}
                value={filters.user}
                sorted={false}
              />
            </FilterBox>
            <FilterBox>
              <FilterSelect
                hasPrimaryText={false}
                label="Sort by time"
                onChange={(e, index, value) =>
                  setFilters(prev => ({ ...prev, time: value }))
                }
                options={filterOptions.sortByTimes.map(item => ({
                  label: item,
                  value: item,
                }))}
                value={filters.time}
                sorted={false}
              />
            </FilterBox>
          </FiltersWrapper>
        </LayoutDashboard>
        <SimpleTableTable
          itemsPerPage={5}
          header={header}
          data={logs}
          showPages={true}
          disableHover={true}
        />
      </div>
    </Fragment>
  )
}

export default withStyles(styles)(LogsContainer)
